"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All searchbar translations for the ESN
var SearchBar = {
  search_keyword: {
    nl: 'Ondernemingen, categorieën, ...',
    fr: 'Entreprises, catégories, ...',
    en: 'Enterprises, categories, ...'
  },
  search_location: {
    nl: 'Postcode, Gemeente, deelgemeente, ...',
    fr: 'Code postal, Municipalité, district, ...',
    en: 'Postalcode, Municipality, sub municipality, ...'
  },
  selected_location_single: {
    nl: 'geselecteerde locatie',
    fr: 'emplacements sélectionnées',
    en: 'selected location'
  },
  selected_location_multi: {
    nl: 'geselecteerde locaties',
    fr: 'emplacements sélectionnées',
    en: 'selected locations'
  },
  btb_info: {
    nl: 'B2B: Ondernemingen die producten en / of diensten aan andere bedrijven leveren.',
    fr: 'B2B: Entreprises qui fournissent des produits et / ou des services à d’autres entreprises.',
    en: 'B2B: Enterprises that supply products and / or services to other companies.'
  },
  btc_info: {
    nl: 'B2C: Ondernemingen die producten en / of diensten leveren aan consumenten.',
    fr: 'B2C: Entreprises qui fournissent des produits et / ou des services aux consommateurs.',
    en: 'B2C: Enterprises that provide products and / or services to consumers.'
  },
  location_is_empty: {
    nl: 'Geef minstens één locatie door',
    fr: 'Veuillez ajouter au moins un lieu',
    en: 'Please add at least one location'
  }
};
var _default = SearchBar;
exports["default"] = _default;